module.exports = __webpack_public_path__ + "static/media/ws_logo.0cefbcc2.png";